var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import http from 'app/services/http';
import { getLivePoster, publishLivePoster, subscribeLivePoster } from '../livePoster';
import { VIDEO_VENDORS } from '../vendors';
/**
 * Hikvision adapter: live via Node (HikCentral previewURLs + go2rtc MSE/WebRTC).
 * Preview tiles: one-shot JPEG from control API — no WebRTC per tile.
 */
export const hikvisionAdapter = {
    vendor: VIDEO_VENDORS.HIKVISION,
    supportsPreviewStreams: false,
    supportsPreviewPosters: true,
    supportsArchive: false,
    requiresFlvJs: false,
    skipPosterFetchWhenSelected: true,
    deferPreviewsUntilLivePoster: true,
    previewKickTimeoutMs: 1400,
    retryLiveOnTransientError: true,
    livePosterBus: {
        publish: publishLivePoster,
        get: getLivePoster,
        subscribe: subscribeLivePoster,
    },
    getChannels() {
        return [];
    },
    getLivePlayback(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (params.transportId == null) {
                throw new Error('Hikvision live requires transportId');
            }
            const { data } = yield http.post(`/map/transport/${params.transportId}/broadcast/live`, {
                channelId: params.channelId,
            });
            return {
                kind: data.kind,
                url: data.url,
                isLive: true,
                sourceCodec: data.sourceCodec,
                strategy: data.strategy,
                streamName: data.streamName,
                channelId: data.channelId || params.channelId,
                deviceId: data.deviceId || params.deviceId,
                fallback: data.fallback
                    ? {
                        kind: data.fallback.kind,
                        url: data.fallback.url,
                        isLive: true,
                        strategy: data.fallback.strategy,
                    }
                    : undefined,
            };
        });
    },
    getArchivePlayback(_params) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    },
    getPreviewPlayback(_params) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    },
    getPreviewPosterUrl(params) {
        if (params.transportId == null) {
            return null;
        }
        return `/map/transport/${params.transportId}/broadcast/preview?channelId=${encodeURIComponent(String(params.channelId))}`;
    },
    releaseLive(_a) {
        return __awaiter(this, arguments, void 0, function* ({ transportId, streamName }) {
            if (!streamName) {
                return;
            }
            try {
                yield http.post(`/map/transport/${transportId}/broadcast/live/release`, { streamName });
            }
            catch (_b) {
                // best-effort
            }
        });
    },
    getEventLabel(type) {
        return String(type);
    },
};
